import React, { useState, useEffect } from "react"

import DataTable from "components/Tables/DataTable"
import dayjs from "dayjs"
import Export from "components/ExportXLSX"
import { downloadXLXS } from "helpers/xlsx_helpers"
import { Button, Row, Col, Label, Spinner } from "reactstrap"
import DatePicker from "react-datepicker"
import { useFormik } from "formik"
import { getAuditoriaLogsByDate } from "api"
import toastHandler from "toastHandler"
import Tooltip from "@mui/material/Tooltip"

const AuditoriaLogs = ({ auditoriaLogs, setAuditoriaLogs }) => {
  const [startDate, setStartDate] = useState(
    typeof auditoriaLogs.fecha === "string"
      ? new Date(auditoriaLogs.fecha)
      : auditoriaLogs.fecha,
  )
  const [endDate, setEndDate] = useState(
    typeof auditoriaLogs.fecha === "string"
      ? new Date(auditoriaLogs.fecha)
      : auditoriaLogs.fecha,
  )
  const setError = toastHandler(state => state.setError)
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {},

    onSubmit: () => {
      getAuditoriaLogsByDate(
        startDate ? dayjs(startDate).format("YYYY-MM-DD") : "none",
        endDate ? dayjs(endDate).format("YYYY-MM-DD") : "none",
      )
        .then(logs => {
          setAuditoriaLogs(logs)
        })
        .catch(setError)
        .finally(setLoading)
      setLoading(true)
    },
  })

  const { handleSubmit } = formik

  const columns = [
    {
      name: "Id",
      selector: row => row.id,
      maxWidth: "100px",
      sortable: true,
    },
    {
      name: "Fecha",
      selector: row => dayjs(row.fecha).format("DD/MM/YYYY"),
      maxWidth: "110px",
      sortable: true,
    },
    {
      name: "Hora",
      selector: row => dayjs(row.fecha).format("HH:mm:ss"),
      maxWidth: "110px",
      sortable: true,
    },
    {
      name: "Evento",
      selector: row => row.evento,
      maxWidth: "170px",
      sortable: true,
    },
    {
      name: "Descripción",
      selector: row => row.descripcion,
      grow: 2,
      maxWidth: "900px",
    },
    {
      name: "Usuario",
      selector: row => row.usuario,
      maxWidth: "110px",
      sortable: true,
    },
    {
      name: "Valor Anterior",
      selector: row => (
        <div className="d-flex align-items-center">
          <Tooltip title={row.valorAnterior}>
            <div className="badge badge-soft-primary font-size-11 m-1">
              {row.valorAnterior}
            </div>
          </Tooltip>
        </div>
      ),
      minWidth: "110px",
    },
    {
      name: "Valor Actual",
      selector: row => (
        <div className="d-flex align-items-center">
          <Tooltip title={row.valorActual}>
            <div className="badge badge-soft-primary font-size-11 m-1">
              {row.valorActual}
            </div>
          </Tooltip>
        </div>
      ),
      minWidth: "110px",
    },
  ]

  useEffect(() => {
    loading
      ? (document.body.style.cursor = "wait")
      : (document.body.style.cursor = "default")
  }, [loading])

  return (
    <div className="justify-content-end mb-4">
      <div className="d-flex justify-content-start">
        <form onSubmit={handleSubmit}>
          <Row className="gy-3 mb-4">
            <Col md={6} lg={3}>
              <Label className="mb-2 font-size-12">Desde:</Label>
              <DatePicker
                locale="es"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                placeholderText="Desde.."
                onChange={date => {
                  setStartDate(date)
                }}
                className="form-control shadow-none"
                maxDate={new Date() || endDate}
              />
            </Col>
            <Col md={6} lg={3}>
              <Label className="mb-2 font-size-12">Hasta:</Label>
              <DatePicker
                locale="es"
                dateFormat="dd/MM/yyyy"
                selected={endDate}
                placeholderText="Hasta.."
                onChange={date => {
                  setEndDate(date)
                }}
                className="form-control shadow-none"
                minDate={startDate}
                maxDate={new Date()}
              />
            </Col>
            <Col className="d-flex align-items-end ">
              {loading ? (
                <Spinner color="primary" size={"sm"} className="ms-1" />
              ) : (
                <Button color="primary" className="shadow-none" type="submit">
                  Buscar
                </Button>
              )}
            </Col>
          </Row>
        </form>
        <div className="d-flex align-items-center justify-content-center gap-4 mt-2">
          <Export
            onExport={() =>
              downloadXLXS(
                auditoriaLogs.map(item => ({
                  Id: item.id,
                  Fecha: dayjs(item.fecha).format("DD/MM/YYYY"),
                  Hora: dayjs(item.fecha).format("HH:mm:ss"),
                  Evento: item.evento,
                  Descripción: item.descripcion,
                  Usuario: item.usuario,
                  "Valor Anterior": item.valorAnterior,
                  "Valor Actual": item.valorActual,
                })),
                "EWAN-AuditoriaLog",
                new Date(),
              )
            }
          />
        </div>
      </div>
      <DataTable columns={columns} data={auditoriaLogs} disabled={loading} />
    </div>
  )
}

export default AuditoriaLogs
